import { z } from 'zod'

export const residentDefaultSchema = z
  .object({
    rental_status: z.string().min(1, 'Rental Status is required.'),
    rental_progress: z.string().min(1, 'Rental Progress is required.'),
  })
  .passthrough()

export const DEFAULT_EVIDENCE_REMOVE_MESSAGE =
  'Please confirm that you really want to remove this default evidence from this case'

export const L1_REVIEW_RECOMMENDATION_TITLE = 'L1 Review Recommendation'
export const L1_REVIEW_RECOMMENDATION_MESSAGE = `Before a payment/denial/reopen recommendation may be made on a reimbursement,
L1 review notes must be posted to the Internal Message Board and identified as such.
All Reimbursements must pass L1 review prior to receiving a settlement recommendation.`

/** Raw API body when a second L1 review recommendation is posted (Angular `error.error`). */
export const L1_REVIEW_ALREADY_EXISTS_API_ERROR = 'Default notes review already exist'

/**
 * Angular `resident-edit-new` dialog when API returns {@link L1_REVIEW_ALREADY_EXISTS_API_ERROR}.
 * Title: {@link L1_REVIEW_RECOMMENDATION_TITLE}.
 */
export const L1_REVIEW_ALREADY_EXISTS_MESSAGE = `An L1 review recommendation has already been submitted for this reimbursement.
If you would like for additional comments to be considered in the original L1 Review Recommendation,
just save as notes and include the additional information. If the recommendation has changed,
the reimbursement needs to be reprocessed for a new L1 Review Recommendation.`
